//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/halo/keyring.proto.
 */
export const file_dxos_halo_keyring = /*@__PURE__*/ fileDesc("ChdkeG9zL2hhbG8va2V5cmluZy5wcm90bxIRZHhvcy5oYWxvLmtleXJpbmciSQoJS2V5UmVjb3JkEhIKCnB1YmxpY19rZXkYASABKAwSGAoLcHJpdmF0ZV9rZXkYAiABKAxIAIgBAUIOCgxfcHJpdmF0ZV9rZXliBnByb3RvMw");
/**
 * Describes the message dxos.halo.keyring.KeyRecord.
 * Use `create(KeyRecordSchema)` to create a new message.
 */
export const KeyRecordSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_keyring, 0);
//# sourceMappingURL=keyring_pb.js.map